module.exports = __webpack_public_path__ + "fonts/173541f.woff";